// Client-side route navigation between the three top-level routes
// (workbench "/", "/security-room", "/admin").
//
// These routes used to be plain <a href> links, which trigger a FULL page
// reload inside the Tauri/webview. A full reload unmounts WorkbenchView and
// destroys every live xterm instance — so navigating to the Security Room and
// back made all open terminals disappear (the PTYs survive on the Bun host,
// but the front-end panes were torn down and not reliably reattached until a
// full app relaunch).
//
// App.tsx already implements client-side routing: it listens for popstate and
// keeps each visited route mounted (just `hidden`) so terminals/chats/composer
// state persist across navigation. Driving navigation through history.pushState
// + a synthetic popstate event engages that path, so WorkbenchView is never
// unmounted and the terminals stay alive.
import type { MouseEvent as ReactMouseEvent } from "react";
export function navigateRoute(path: string): void {
  if (window.location.pathname + window.location.search === path) return;
  window.history.pushState({}, "", path);
  window.dispatchEvent(new PopStateEvent("popstate"));
}

// Use as the onClick for an <a href={path}>: keeps the href (right-click / open
// in new window / accessibility) but intercepts a plain left-click to navigate
// client-side. Modifier-clicks (cmd/ctrl/shift/alt) fall through to default.
export function routeLinkHandler(path: string) {
  return (event: ReactMouseEvent<HTMLAnchorElement>) => {
    if (event.defaultPrevented) return;
    if (event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    navigateRoute(path);
  };
}
